export default __webpack_public_path__ + "static/media/typewriter.4c96e1e2.png";